export * from './TextArticleTIcon';
export * from './TextArticleTIcon16Light';
export * from './TextArticleTIcon16Regular';
export * from './TextArticleTIcon16Solid';
export * from './TextArticleTIcon20Light';
export * from './TextArticleTIcon20Regular';
export * from './TextArticleTIcon20Solid';
export * from './TextArticleTIcon24Regular';
export * from './TextArticleTIcon24Solid';
export * from './TextArticleTIcon32Regular';
export * from './TextArticleTIcon64Regular';
